import { Country } from '@types';

export const countryTabList = [
    { key: Country.GB, label: 'GB' },
    { key: Country.US, label: 'US' },
];
